module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Umbrella-f77163c11d9d55e839264a8f40b95a58.svg";